<template>

  <div class="row">
    <div class="col-12">

      <div class="card">
        <div class="card-body">

          <h4 class="card-title">1분만에 완성되는 나만의 홈페이지</h4>
          <p class="card-title-desc">
            템플릿 고르고, 이미지 바꾸고, 링크 넣고 바로시작
          </p>


          <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
            <ol class="carousel-indicators">
              <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active">
              </li>
              <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"></li>
              <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2"></li>
              <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="3"></li>
            </ol>
            <div class="carousel-inner" role="listbox">
              <div class="carousel-item active">
                <banner1/>
              </div>
              <div class="carousel-item">
                <banner2/>
              </div>
              <div class="carousel-item">
                <banner3/>
              </div>
              <div class="carousel-item">
                <banner4/>
              </div>
            </div>
          </div>

        </div>
      </div>


    </div>
  </div>

</template>
<script>
import banner1 from './banner/banner1'
import banner2 from './banner/banner2'
import banner3 from './banner/banner3'
import banner4 from './banner/banner4'
export default {
  components: {
    banner1,
    banner2,
    banner3,
    banner4,
  },
}
</script>